// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../types/index';
import { media } from '../../../helpers/index';

const FacetsWrapper = styled<any, Theme>('section')`
  background-color: ${props => props.theme.assortment.facets.backgroundColor.drawer};
  padding: 1rem;

  ${media.lg(css`
    background-color: ${props => props.theme.assortment.facets.backgroundColor.default};
    padding: 0 0.5rem;
  `)}
`;

export default FacetsWrapper;
